<script>
    import SiteHeader from '../SiteHeader'

    export default {
        name: 'Index',
        components: {
            SiteHeader
        }
    }
</script>

<template lang="pug">

  .foo
    site-header
    .row.banner
      .col.s11.offset-s1
        router-link(to='/educator')
          h4  Educator Portal
    router-view

</template>

<style lang="sass" scoped>

  .banner 
    background-position: 0 30%;
    background-image: url("~@/assets/1_educatorportal.jpg");
    background-repeat: no-repeat;
    background-size: cover;    


  .banner h4 
    padding-top: 18vh;
    font-weight: thick;
    color: #fff;
    font-size: 2.5em

</style>